import Box from "@material-ui/core/esm/Box";
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Title, Info } from 'components/Text';
import VehicleIcon from 'components/VehicleIcon/VehicleIcon';
import { NOT_AVAILABLE } from 'constants/text';
import useCountry from 'hooks/language/useCountry';
import getVehicleSizeTranslation from 'utils/vehicle/getVehicleSizeTranslation';
import VehicleColumn from './VehicleColumn';
import useStyles from './VehicleInfoStyles';
export default function VehicleInfo({
  vehicle,
  showVehicleIcon
}) {
  const {
    t
  } = useTranslation();
  const {
    getChosenCountryObjectName
  } = useCountry();
  const {
    vehicleInfoRoot,
    title,
    vehicleInfo,
    row
  } = useStyles();
  if (!vehicle || !vehicle?.registrationNumber) {
    return /*#__PURE__*/React.createElement("div", {
      className: vehicleInfoRoot
    }, /*#__PURE__*/React.createElement(Info, null, t('vehicle.no_attached_vehicle')));
  }
  const {
    nationality,
    registrationNumber,
    size,
    brand,
    model,
    euClass,
    isMobileHome
  } = vehicle;
  let mobileHome = NOT_AVAILABLE;
  if (isMobileHome === true) mobileHome = t('general.yes');else if (isMobileHome === false) mobileHome = t('general.no');
  return /*#__PURE__*/React.createElement("div", {
    className: vehicleInfoRoot
  }, /*#__PURE__*/React.createElement(Box, {
    className: row
  }, showVehicleIcon && /*#__PURE__*/React.createElement(VehicleIcon, {
    vehicle: vehicle
  }), /*#__PURE__*/React.createElement(Title, {
    className: clsx({
      [title]: showVehicleIcon
    })
  }, t('vehicles.vehicle'))), /*#__PURE__*/React.createElement("div", {
    className: vehicleInfo
  }, /*#__PURE__*/React.createElement(VehicleColumn, {
    title: t('vehicles.registration_number'),
    value: registrationNumber || NOT_AVAILABLE
  }), /*#__PURE__*/React.createElement(VehicleColumn, {
    title: t('vehicles.nationality'),
    value: getChosenCountryObjectName(nationality) || nationality || NOT_AVAILABLE
  }), /*#__PURE__*/React.createElement(VehicleColumn, {
    title: t('vehicles.brand'),
    value: brand || NOT_AVAILABLE
  }), /*#__PURE__*/React.createElement(VehicleColumn, {
    title: t('vehicles.weight'),
    value: t(getVehicleSizeTranslation(size))
  }), /*#__PURE__*/React.createElement(VehicleColumn, {
    title: t('vehicles.model'),
    value: model || NOT_AVAILABLE
  }), /*#__PURE__*/React.createElement(VehicleColumn, {
    title: t('vehicles.eu_class'),
    value: euClass || NOT_AVAILABLE
  }), /*#__PURE__*/React.createElement(VehicleColumn, {
    title: t('vehicles.is_mobile_home'),
    value: mobileHome
  })));
}
VehicleInfo.defaultProps = {
  showVehicleIcon: true
};